import { ChargerModelEnum } from '@/app/enums/ChargerModelEnum';

import type { ChargersWizardData } from './types';

export const chargersWizardData: ChargersWizardData = {
  [ChargerModelEnum.ChargerOura3]: {
    styleStep: {
      carouselImages: null,
      image: {
        altMsgKey: 'horizon_and_heritage_rings_alt',
        originalSrc:
          'https://s3.amazonaws.com/ouraring.com/images/product/wizard/oura-ring-3.jpg',
        inverseText: false,
      },
      selector: {
        altMsgKey: 'horizon_and_heritage_rings_alt',
        descMsgKey: 'horizon_heritage_styles',
        originalSrc:
          'https://s3.amazonaws.com/ouraring.com/images/product/wizard/gen3-selector.png',
        swatch: {
          altMsgKey: '',
          originalSrc: '',
          slug: '',
        },
      },
    },
    finishStep: null,
    sizeStep: {
      carouselImages: [
        {
          altMsgKey: 'pdp_carousel_alt_charger_set_video',
          content: null,
          contentTitle: null,
          inverseText: true,
          mobileSrc:
            'https://s3.amazonaws.com/ouraring.com/images/product/wizard/pdp-charger-set-mobile.mp4',
          originalSrc:
            'https://s3.amazonaws.com/ouraring.com/images/product/wizard/pdp-charger-set-new.mp4',
          thumbnailSrc:
            'https://s3.amazonaws.com/ouraring.com/images/product/wizard/pdp-charger-set-thumbnail-1.jpg',
          originalSrcKey: null,
        },
        {
          altMsgKey: 'pdp_carousel_alt_charger_set',
          content: null,
          contentTitle: null,
          inverseText: false,
          mobileSrc: null,
          originalSrc:
            'https://s3.amazonaws.com/ouraring.com/images/product/wizard/pdp-charger-set-slide2.png',
          thumbnailSrc:
            'https://s3.amazonaws.com/ouraring.com/images/product/wizard/pdp-charger-set-2.png',
          originalSrcKey: null,
        },
      ],
      image: null,
      selector: null,
    },
  },
  [ChargerModelEnum.ChargerOura4]: {
    styleStep: {
      carouselImages: null,
      image: {
        altMsgKey: 'or4_ring_alt',
        originalSrc:
          'https://s3.amazonaws.com/ouraring.com/images/product/wizard/oura-ring-4-multi.jpg',
        inverseText: true,
      },
      selector: {
        altMsgKey: 'or4_ring_alt',
        descMsgKey: '',
        originalSrc:
          'https://s3.amazonaws.com/ouraring.com/images/product/wizard/oura-ring-4-selector.png',
        swatch: {
          altMsgKey: '',
          originalSrc: '',
          slug: '',
        },
      },
    },
    finishStep: null,
    sizeStep: {
      carouselImages: [
        {
          altMsgKey: 'pdp_carousel_alt_charger_set_video',
          content: null,
          contentTitle: null,
          mobileSrc:
            'https://s3.amazonaws.com/ouraring.com/images/product/wizard/pdp-or4-charger-mobile.mp4',
          originalSrc:
            'https://s3.amazonaws.com/ouraring.com/images/product/wizard/pdp-or4-charger.mp4',
          thumbnailSrc:
            'https://s3.amazonaws.com/ouraring.com/images/product/wizard/pdp-or4-charger-thumb.jpg',
          inverseText: true,
          originalSrcKey: null,
        },
        {
          altMsgKey: 'pdp_carousel_alt_charger_set',
          content: null,
          contentTitle: null,
          inverseText: false,
          mobileSrc: null,
          originalSrc:
            'https://s3.amazonaws.com/ouraring.com/images/product/wizard/pdp-or4-charger-upclose.jpg',
          thumbnailSrc:
            'https://s3.amazonaws.com/ouraring.com/images/product/wizard/pdp-or4-charger-upclose-thumb.jpg',
          originalSrcKey: null,
        },
      ],
      image: null,
      selector: null,
    },
  },
};
